import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import "./AgentDisplay.scss";
import apiService from "../../../global/common/environment";

const AgentDisplay = () => {
    const [agents, setAgents] = useState([]);
    const [filteredAgents, setFilteredAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const agentsPerPage = 5;

    useEffect(() => {
        getAllAgents();
    }, []);

    useEffect(() => {
        setFilteredAgents(
            agents.filter(agent =>
                (`${agent?.agentId?.first_name} ${agent?.agentId?.last_name}`)
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, agents]);

    const getAllAgents = async () => {
        try {
            const res = await axios.get(apiService.getAllagentsInfo);
            setAgents(res.data);
            setFilteredAgents(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const changeStatus = async (id, status) => {
        try {
            await axios.put(apiService.updateAgentInfo(id), { verified: status });
            getAllAgents();
        } catch (err) {
            console.error(err);
        }
    };

    const handleViewDetails = (agent) => {
        setSelectedAgent(agent);
        setShowDetails(true);
    };

    const handleCloseModal = () => {
        setShowDetails(false);
        setSelectedAgent(null);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const indexOfLastAgent = currentPage * agentsPerPage;
    const indexOfFirstAgent = indexOfLastAgent - agentsPerPage;
    const currentAgents = filteredAgents.slice(indexOfFirstAgent, indexOfLastAgent);

    return (
        <div className="admin-dashboard-container">
            <h1 className="dashboard-title">Agents</h1>
            <input
                type="text"
                placeholder="Search by name..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="search-input"
            />
            
            <table className="admin-dashboard-table">
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Agency</th>
                        <th>Country</th>
                        <th>Phone</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentAgents.length > 0 ? (
                        currentAgents.map((agent, index) => (
                            <tr key={index}>
                                <td>{agent?.agentId?.first_name || "N/A"}</td>
                                <td>{agent?.agentId?.last_name || "N/A"}</td>
                                <td>{agent?.agentId?.email || "N/A"}</td>
                                <td>{agent?.organizationName || "N/A"}</td>
                                <td>{agent?.country || "N/A"}</td>
                                <td>{agent?.agentId?.mobile_no || "N/A"}</td>
                                <td>
                                    <span className={`status-badge ${agent?.verified === "active" ? "active" : "inactive"}`}>
                                        {agent?.verified || "N/A"}
                                    </span>
                                </td>
                                <td>
                                    <button className="toggle-status-btn" onClick={() => changeStatus(agent._id, agent?.verified === "active" ? "inactive" : "active")}> {agent?.verified === "active" ? "Inactive" : "Active"} </button>
                                    <button className="view-details-btn" onClick={() => handleViewDetails(agent)}> <FaEye /> </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8">No agents found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="pagination">
                <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                <span>Page {currentPage} of {Math.ceil(filteredAgents.length / agentsPerPage)}</span>
                <button disabled={indexOfLastAgent >= filteredAgents.length} onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
            </div>
            {showDetails && selectedAgent && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={handleCloseModal}>&times;</span>
                        <h2>Agent Details</h2>
                        <p><strong>First Name:</strong> {selectedAgent?.agentId?.first_name || "N/A"}</p>
                        <p><strong>Last Name:</strong> {selectedAgent?.agentId?.last_name || "N/A"}</p>
                        <p><strong>Email:</strong> {selectedAgent?.agentId?.email || "N/A"}</p>
                        <p><strong>Agency:</strong> {selectedAgent?.organizationName || "N/A"}</p>
                        <p><strong>Country:</strong> {selectedAgent?.country || "N/A"}</p>
                        <p><strong>Phone:</strong> {selectedAgent?.agentId?.mobile_no || "N/A"}</p>
                        <p><strong>Status:</strong> {selectedAgent?.verified || "N/A"}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AgentDisplay;
